import { render, staticRenderFns } from "./PxOpenOferta.vue?vue&type=template&id=234e9ad1"
import script from "./PxOpenOferta.vue?vue&type=script&lang=js"
export * from "./PxOpenOferta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports